import { getParams } from '@cigna/cigna_digital_dcws_cigna-frontend/src/js/util/url';
console.log('test');

var setElementText = function setElementText(selector, content) {
  var instances = document.querySelectorAll("".concat(selector));
  instances.forEach(function (el) {
    el.textContent = content;
  });
};

var url = location.pathname; // gets the url location

var pagename = url.substring(url.lastIndexOf('/') + 1).split('.html').join(''); // finds the filename.html at the last / in the url loc
// if page names don't match the it assumes index.html and defaults to sending 1

var getCMScode = function getCMScode(type) {
  var pages = {
    'learn-the-basics': '2',
    'our-benefits': '3',
    'choosing-a-plan': '4',
    default: '1'
  };
  return "".concat(pages[type] || pages.default);
}; // eslint-disable-next-line no-return-assign


var hide = function hide() {
  for (var _len = arguments.length, el = new Array(_len), _key = 0; _key < _len; _key++) {
    el[_key] = arguments[_key];
  }

  return [].concat(el).forEach(function (e) {
    return e.style.display = 'none';
  });
}; // eslint-disable-next-line no-return-assign


var show = function show() {
  for (var _len2 = arguments.length, el = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    el[_key2] = arguments[_key2];
  }

  return [].concat(el).forEach(function (e) {
    return e.style.display = '';
  });
};

var updateCompanyNames = function updateCompanyNames(div, company) {
  setElementText('.div-name', company + {
    chlic: ' Health and Life Insurance Company',
    arlic: ' Retirement Life Insurance Company',
    lalic: ' American Life Insurance Company',
    loyal: ' American Life Insurance Company',
    cnhic: ' National Health Insurance Company'
  }[div]);
};

var updateCMSCode = function updateCMSCode(div) {
  setElementText('.page-id', "".concat(getCMScode(pagename)));
  setElementText('.div-id', "".concat(div.toUpperCase()));
};

var hideGeneralContent = function hideGeneralContent(state) {
  var page = getCMScode(pagename);

  if (state === '-STE') {
    $('.not-ste-specific').hide().removeClass('d-flex');
    $('.ste-specific').show();
    if (page === '3' || page === '4') $('.ste-specific-3-4').show();
  }

  if (state === '-NH') {
    $('.not-nh-specific').hide();
    $('.nh-specific').show();
  }
};

var hideContentForKs = function hideContentForKs() {
  var ksOnly = document.querySelector('.ks-only');
  var iconBlocks = document.querySelectorAll('.icon-block-2');

  if (iconBlocks.length) {
    iconBlocks.forEach(function (ele) {
      var header = ele.querySelector('header');
      if (header.textContent.includes('Additional Programs')) hide(ele);
    });
  }

  console.log(ksOnly);
  if (ksOnly) hide(ksOnly);
};

var showTxContent = function showTxContent() {
  var txOnly = document.querySelectorAll('.tx-only');
  var header = document.querySelector('.navbar');
  var txHeading = document.createElement('div');

  if (header) {
    txHeading.setAttribute('class', 'col-md-5 micro-text font-weight-bold align-self-center m-auto');
    txHeading.textContent = 'Our company and agents are not connected with or endorsed by the U.S. Government or the federal Medicare program. This is a solicitation for insurance. An insurance agent may contact you.';
    header.children[0].appendChild(txHeading);
  }

  if (txOnly.length) show(txOnly);
};

var updateContent = function updateContent() {
  var params = getParams();
  var cid = params.cid;
  console.log('params = ', params);
  var companyNames = {
    chlic: 'Cigna',
    arlic: 'American',
    lalic: 'Loyal',
    loyal: 'Loyal',
    cnhic: 'Cigna'
  };
  var div = params.div;
  div = div || 'chlic';
  div = div === 'lalic' ? 'loyal' : div.toLowerCase();

  if (div === 'chlic' && cid === 's051') {
    showTxContent();
    updateCMSCode(div, '-TX');
  } else if (div === 'chlic' && cid === 's050') {
    hideContentForKs();
    updateCMSCode(div, '-KS');
  } else if (div === 'chlic' && cid === 's055') {
    hideGeneralContent('-STE');
    updateCMSCode(div, '-STE');
  } else if (div === 'arlic' && cid === 's056') {
    hideGeneralContent('-NH');
    updateCMSCode(div, '-NH');
  } else updateCMSCode(div);

  updateCompanyNames(div, companyNames[div]);
  $(".".concat(div, "-").concat(cid)).show(); // view additional content based off of div name

  if (div === 'chlic') {
    var chlicEles = document.querySelectorAll('.chlic-only');
    chlicEles.forEach(function (ele) {
      ele.classList.remove('chlic-only');
    });
    $('.not-chlic').hide();
    $('.chlic-notice').show();
    $('.chlic-footer-disclaimer').show();

    if (cid === 's064' || cid === 's061' || cid === 's067') {
      var iconBlock = $('.icon-block-2')[6];
      iconBlock.parentNode.removeChild(iconBlock);
    }
  }

  if (div === 'arlic') {
    $('.arlic-notice').show();
    $('.arlic-footer-disclaimer').show();
  }

  if (div === 'loyal') {
    $('.loyal-notice').show();
    $('.loyal-footer-disclaimer').show();
  }

  if (div === 'cnhic') {
    $('.cnhic-notice').show();
  } // view loyal and lalic only content


  if (div === 'loyal' || div === 'lalic') {
    var _chlicEles = document.querySelectorAll('.loyal-only');

    var footerDisclaimer = document.querySelector('.lalic-footer-disclaimer');

    _chlicEles.forEach(function (ele) {
      ele.classList.remove('loyal-only');
    });

    if (footerDisclaimer) {
      footerDisclaimer.style.display = 'block';
    }
  }

  if (div === 'lalic' || div === 'arlic' || div === 'loyal') {
    $('.state-disability-notice').hide();
  }
};

export default updateContent;